module.exports = __webpack_public_path__ + "img/iconToilet_blackBG_large@2x.dc9575f2.png";